export const SIMULATION_SIDE_CARD_BREAKPOINT = 1120
